<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/transplus_about1.jpg')"
      />
      <div class="content-center">
        <div class="container">
          <h1
            class="title"
            v-html="$t('Company.About')"
          >
            About us
          </h1>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2
              class="title"
              v-html="$t('Company.Who')"
            >
              <span class="tpgreen">Who </span> we are.
            </h2>
            <h5
              class="description"
              v-html="$t('Company.whodesc')"
            >
              Transplus is a reliable North American supply chain service provider positioned to meet the needs of regional businesses and global brands across Canada and the U.S. We are a privately owned and managed company that provides customized solutions for each client and their specific business needs.           
            </h5>
          </div>
        </div>
      </div>
    </div>

    <hr class="tpgreen">
    
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h2
              class="title"
              v-html="$t('Company.Story')"
            >
              Our <span class="tpgreen">story.</span>
            </h2>
            <h5
              class="description"
              v-html="$t('Company.storydesc')"
            >
              Founded in 1993 by Vince Mazzei, Transplus began as a local Canadian transport operation. With a clear understanding of the impact of a global economy, we recognized the value of moving merchandise expeditiously across borders. We began by establishing a solid, dependable operation in North America and then grew our international network. Because our customers’ needs have expanded and evolved, so have our services. Today, we manage and distribute consumer goods across the globe.             
            </h5>
          </div>
        </div>
      </div>
    </div>

    <hr class="tpgreen">

    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2
              class="title"
              v-html="$t('Company.People')"
            >
              Our <span class="tpgreen">people.</span>
            </h2>
            <h5
              class="description"
              v-html="$t('Company.peopledesc')"
            >
              Our people work holistically at every stage of supply chain management. Together, we embrace collaboration, diversity, technology, and innovation.             
            </h5>
          </div>
        </div>
      </div>
    </div>

    <hr class="tpgreen">


    <!-- newsection JOE  -->
    <div
      class="section"
      style="border: 0px solid green;"
    >
      <h2
        class="title text-center"
        v-html="$t('Company.Promise')"
      >
        Our promise to <span class="tpgreen">deliver.</span>
      </h2> 

      <div class="container elgrey">                
        <div class="row">                  
          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold;"
              v-html="$t('Company.Strategy')"
            >Strategically Driven</span>
            <span
              class="right light"
              v-html="$t('Company.Strategydesc')"
            >Through clear and measurable objectives, we are dedicated to providing turn-key logistics from departure to destination. Our operating model is based on procedures and policies that we review regularly to ensure efficient and secure operations.</span>
          </div>

          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Company.Reliable')"
            >Highly Reliable</span>
            <span
              class="right light"
              v-html="$t('Company.Reliabledesc')"
            >Supply chain management is an around the clock business operation. We operate and are available after hours and on weekends. We are solutions oriented and dedicated to doing what it takes to honour our commitments.</span>
          </div>

          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Company.Connectivity')"
            >Fueled by Connectivity</span>
            <span
              class="center light"
              v-html="$t('Company.Connectivitydesc')"
            >We pride ourselves on building and maintaining long-term regional and international customer and supplier partnerships. Communication through transparency and accountability is at the core of our business.</span>
          </div>
          
          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Company.Tech')"
            >Technology Savvy</span>
            <span
              class="right light"
              v-html="$t('Company.Techdesc')"
            >Technology is leveraged to fuel business growth and transfer synergy to all of our services. We promote effective communication between our systems and yours with our cutting-edge electronic data interchange (EDI), warehouse management system (WMS), transportation management system (TMS), and yard management system (YMS).</span>              
          </div>

          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Company.Green')"
            >Green Perspective</span>
            <span
              class="right light"
              v-html="$t('Company.Greendesc')"
            >The need to reduce our corporate carbon footprint (CCF) is a major priority. We adapt our operations and strategies using green alternatives such as running our fleet on eco-friendly fuels.</span>              
          </div>
        </div>
      </div>
    </div>
    <!--- end section joe -->
  </div>
</template>
<script>
import { Card } from '@/components';
export default { 
  components: { Card },
  data() {
    return {
      bday: new Date().getFullYear() - 1993,     
      imgTech: "img/elec2.jpg",
      imgSafe: "img/bg4.jpg",
    };
  }
};
</script>
<style scoped>
.am-opacity {
  opacity:1;
}
.am-opacity:hover {
  opacity:1;
}
.am-highlight {
  color:#cccccc;
}
.am-highlight:hover {
  color:#666666;
}

@media only screen and (max-width: 600px) { 
  .page-header-small{
            min-height: 40vh;
            max-height: 440px;
    }
  .title{
    font-size:2.75em;
  }
}
</style>
